const DEFAULT_CONTENT_WIDTH_IN_NUM = 1300;
const DEFAULT_CONTENT_WIDTH = 'max-w-[130rem] sm:w-[80%] w-[calc(100%-theme(space.7))]';

export { DEFAULT_CONTENT_WIDTH, DEFAULT_CONTENT_WIDTH_IN_NUM };

export const HERO_SECTION_BACKGROUND_VIDEO =
  'https://colochousing-production.s3.eu-west-1.amazonaws.com/hero-video_muted.mp4';
export const HERO_SECTION_PLACEHOLDER_IMAGE = require('@assets/images/marketplace/hero-section-video-background.png');
export const HERO_SECTION_FALLBACK_IMAGE = require('@assets/images/marketplace/hero-section-background.jpg');
